import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  NgForm,
  Validators,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
} from '@angular/material/core';

import { PatientAddress } from 'src/app/core/models/patient/patientAddress';
import { PharmacyDetails } from 'src/app/core/models/patient/pharmacyDetails';

import {
  APP_DATE_FORMATS,
  AppDateAdapter,
} from '../../../../core/format-datepicker';
import { CodeTable } from '../../../../core/model/v2/code-table';
import {
  PatientContactPreferences,
} from '../../../../core/models/patient/contactPreferences';
import { Patient } from '../../../../core/models/patient/patient';
import {
  PatientContactPreferencesReq,
} from '../../../../core/models/patient/patient-contact-preferences-req';
import {
  PatientAdvancedDirective,
} from '../../../../core/models/patient/patientAdvancedDirective';
import {
  PatientChildren,
} from '../../../../core/models/patient/patientChildren';
import { PatientDrivingLicense } from '../../../../core/models/patient/patientDrivingLicense';
import {
  PatientEmergencyContactInfo,
} from '../../../../core/models/patient/patientEmergencyContactInfo';
import { PatientEmployerInfo } from '../../../../core/models/patient/patientEmployerInfo';
import { PatientInsuranceDetail } from '../../../../core/models/patient/patientInsuranceDetail';
import { PatientMedication } from '../../../../core/models/patient/patientMedication';
import { CommonService } from '../../../../core/services/v2/common.service';
import { PatientService } from '../../../../core/services/v2/patient.service';
import { PracticeService } from '../../../../core/services/v2/practice.service';
import { UserService } from '../../../../core/services/v2/user.service';
import { UtilsService } from '../../../../core/services/v2/utils.service';
import {
  MyErrorStateMatcher,
} from '../../../../shared/components/MyErrorStateMatcher/MyErrorStateMatcher.component';

@Component({
  selector: 'app-sidebar-patient-edit',
  templateUrl: './sidebar-patient-edit.component.html',
  styleUrls: ['./sidebar-patient-edit.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
  ]
})
export class SidebarPatientEditComponent implements OnInit {
  @Input() sectionName: string;
  @Input() patientProfile: Patient;
  @Input() emergencyContact: PatientEmergencyContactInfo;
  @Input() childrenGuardian: PatientChildren;
  @Input() advancedDirective: PatientAdvancedDirective;
  @Input() pharmacyPreference: PharmacyDetails;
  @Input() patientInsurance: PatientInsuranceDetail;
  @Input() showEdit: boolean;
  @Output() toggleEvent = new EventEmitter();
  @ViewChild('demographicForm', null) demographicForm: NgForm;
  @ViewChild('physicalCharacterForm', null) physicalCharacterForm: NgForm;
  userId: number;

  editorData;
  //gender: any;
  genderCodes: CodeTable;

  //languages: LanguageDetails[];
  //practitionerlanguageIds: number[];
  languageCodes: CodeTable;

  visuallyImpaired: boolean;
  hearingImpaired: boolean;

  homeContact: PatientContactPreferences;
  mobileContact: PatientContactPreferences;
  workContact: PatientContactPreferences;
  emailContact: PatientContactPreferences;

  placeOfBirth: string;
  dob: any;

  practitionerId: number;
  loader: boolean = false;
  zipCode: string;

  showHideSelected = false;

  statesCodes: CodeTable;
  codeTableSuffix: CodeTable;
  maritalStatusCodes: CodeTable;
  raceCodes: CodeTable;
  ethnicityCodes: CodeTable;
  religiousCodes: CodeTable;
  accompanyAssistCodes: CodeTable;
  genderIdentityCodes: CodeTable;
  sexCodes: CodeTable;
  sexualOrientationCodes: CodeTable;
  ServiceBranchCodes: CodeTable;
  militaryStatusCodes: CodeTable;
  bloodTypeStatusCodes: CodeTable;

  patientEdit: Patient;
  patientWorkAddress: PatientAddress = new PatientAddress();;
  patientEmployer: PatientEmployerInfo = new PatientEmployerInfo();;
  patientDrivingLicense: PatientDrivingLicense = new PatientDrivingLicense();
  patientContactMatcher = new MyErrorStateMatcher();

  homePhoneFormControl = new FormControl('', [Validators.required]);
  mobilePhoneFormControl = new FormControl('', [Validators.required]);

  patientContactForm: FormGroup = new FormGroup({
    mobilePhone: this.mobilePhoneFormControl,
    homePhone: this.homePhoneFormControl
  });

  patientProfileImageFile: any;
  maxDate: Date = new Date();

  constructor(
    private practiceService: PracticeService,
    private patientService: PatientService,
    private userService: UserService,
    private commonService: CommonService,
    private utils: UtilsService,
    private _snackBar: MatSnackBar,
    private datePipe: DatePipe) { }

  ngOnDestroy() {
    //this.intializePatientBio();
  }

  ngOnInit() {
    this.intializePatientBio();
    if (this.userService.userDetail$) {
      this.userService.userDetail$.subscribe(
        (userDetails) => {
          this.userId = userDetails.id;
          this.practitionerId = userDetails.practitionerId;
        },
        (error) => { console.error(error); }
      );
    }
  }


  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  loadCodes() {

    this.statesCodes = this.commonService.getItemCodesFiltered('STATE');

    this.genderCodes = this.commonService.getItemCodesFiltered('GENDER');

    this.codeTableSuffix = this.commonService.getItemCodesFiltered('SUFFIX');

    this.maritalStatusCodes = this.commonService.getItemCodesFiltered('MARITALSTATUS');

    this.raceCodes = this.commonService.getItemCodesFiltered('RACE');

    this.ethnicityCodes = this.commonService.getItemCodesFiltered('ETHNICITY');

    this.religiousCodes = this.commonService.getItemCodesFiltered('RELIGIOUS');

    this.languageCodes = this.commonService.getItemCodesFiltered('LANGUAGE');

    this.accompanyAssistCodes = this.commonService.getItemCodesFiltered('ACCOMPANYASST');

    this.genderIdentityCodes = this.commonService.getItemCodesFiltered('GenderIdentity');

    this.sexCodes = this.commonService.getItemCodesFiltered('SEX');

    this.sexualOrientationCodes = this.commonService.getItemCodesFiltered('SexualOrientation');

    this.ServiceBranchCodes = this.commonService.getItemCodesFiltered('ServiceBranch');

    this.militaryStatusCodes = this.commonService.getItemCodesFiltered('MilitaryStatus');

    this.bloodTypeStatusCodes = this.commonService.getItemCodesFiltered('BLOODTYPE');
  }


  intializePatientBio() {

    this.patientEdit = { ...this.patientProfile };
    this.editorData = this.patientProfile ? this.patientProfile.bio : null;
    this.dob = this.patientProfile ? new Date(this.patientProfile.birthDate) : null;
    this.patientEdit.isVisuallyImpaired = this.patientEdit.isVisuallyImpaired === true ? 'Yes' : 'No';
    this.patientEdit.isHearingImpaired = this.patientEdit.isHearingImpaired === true ? 'Yes' : 'No';
    //let employeeAddresses = 0;
    // let patientWorkAddressList = this.patientEdit.addresses.filter(q => q.type == "WORK");
    // if(patientWorkAddressList.length > 0){
    //   this.patientWorkAddress = patientWorkAddressList[0];
    // }
    this.setPreferredContact();
    this.loadCodes();
    if (this.patientProfile !== undefined) {
      if (this.patientProfile.patientDrivingLicenseDetails) {
        this.patientDrivingLicense = this.patientProfile.patientDrivingLicenseDetails;
        if (this.patientDrivingLicense) {
          this.patientDrivingLicense.heightft = '';
          this.patientDrivingLicense.heightinch = '';
          if (this.patientDrivingLicense.height) {
            let height = this.patientDrivingLicense.height.split("'");
            if (height.length > 1) {
              this.patientDrivingLicense.heightft = height[0];
              this.patientDrivingLicense.heightinch = height[1];
            }
          }
        }
      }
      if (this.patientProfile.patientEmployerInfo && this.patientProfile.patientEmployerInfo.length > 0) {
        this.patientEmployer = this.patientProfile.patientEmployerInfo[0];
      }
      if (this.patientProfile.addresses && this.patientProfile.addresses.length > 0) {
        let patientWorkAddressList = this.patientProfile.addresses.filter(q => q.type == "WORK");
        if (patientWorkAddressList.length > 0) {
          this.patientWorkAddress = patientWorkAddressList[0];
        }
      }
    }
  }
  attachFront(event) {
    if (event.target.files && event.target.files[0]) {
      this.patientProfileImageFile = event.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = () => { // called once readAsDataURL is completed
        // console.log('reader');
        // console.log(reader);
        // console.log(reader.result)
        // console.log(e)
        // console.log('reader blabla');
        this.patientEdit.photoUrl = reader.result.toString();
      }
    }
  }

  cancel() {
    this.showEdit = false;
    this.showHideSelected = true;
    this.toggleEvent.emit(this.patientProfile);
  }
  updateClose(patient: Patient) {
    this.showHideSelected = true;
    if (patient) this.patientProfile = patient;
    this.toggleEvent.emit(this.patientProfile);
  }
  saveProfile() {
    //this.patientEdit.birthDate = this.datePipe.transform(this.dob, 'MM/dd/yyyy');

    if (this.dob) {
      this.patientEdit.birthDate = `${this.dob.getFullYear()}-${this.dob.getMonth() + 1}-${this.dob.getDate()}`
    }
    else {
      this.patientEdit.birthDate = null;
    }

    //console.log('PatientEdit', this.patientEdit);
    const self = this;
    this.patientService.updatePatientDetails(this.patientEdit).subscribe(
      (_) => {
        self.patientProfile = self.patientEdit;
        self.toggleEvent.emit(self.patientProfile);
      },
      (error) => { console.error(error); }
    );

  }
  checkNumberOnly(e) {
    const functionalKeys = ['Backspace', 'ArrowRight', 'ArrowLeft'];
    if (functionalKeys.indexOf(e.key) !== -1) {
      return;
    }
    const keyValue = +e.key;
    if (isNaN(keyValue)) {
      e.preventDefault();
      return;
    }
  }

  updatePhysicalCharacter() {
    const physicalCharacterDetailsData = new FormData();
    const isValid = this.validatePhysicalCharacterDetails();
    if (!isValid) {
      return;
    }
    let height = '';
    if (this.patientDrivingLicense.heightft && this.patientDrivingLicense.heightinch) {
      height = this.patientDrivingLicense.heightft + "'" + this.patientDrivingLicense.heightinch + "''";
    } else if (this.patientDrivingLicense.heightft) {
      height = this.patientDrivingLicense.heightft + "'" + 0 + "''";
    } else if (this.patientDrivingLicense.heightinch) {
      height = 0 + "'" + this.patientDrivingLicense.heightinch + "''";
    } else {
      height = '';
    }
    this.patientDrivingLicense.height = height;
    physicalCharacterDetailsData.append('PatientId', this.patientProfile.id.toString());
    physicalCharacterDetailsData.append('Height', this.patientDrivingLicense.height);
    physicalCharacterDetailsData.append('Weight', this.patientDrivingLicense.weight ? this.patientDrivingLicense.weight.toString() : '');
    physicalCharacterDetailsData.append('EyeColor', this.patientDrivingLicense.eyeColor ? this.patientDrivingLicense.eyeColor.toString() : '');
    physicalCharacterDetailsData.append('HairColor', this.patientDrivingLicense.hairColor ? this.patientDrivingLicense.hairColor.toString() : '');
    physicalCharacterDetailsData.append('BloodType', this.patientDrivingLicense.bloodType);

    this.patientService.updatePatientDrivingLicenseDetails(physicalCharacterDetailsData).subscribe(
      (res) => {
        this.toggleEvent.emit(this.patientProfile);
      },
      (error) => { console.error(error); }
    );
  }
  validatePhysicalCharacterDetails(): boolean {
    if (this.patientDrivingLicense.heightinch) {
      if (+this.patientDrivingLicense.heightinch > 11) {
        this._snackBar.open('Inch value should not be greater than 11', 'Ok', { duration: 5 * 1000 });
        return false;
      }
    }
    return true;
  }

  updateEmployeeInfo() {

    const self = this;
    this.patientWorkAddress.userId = this.userId;
    this.patientWorkAddress.type = "WORK";
    var modifiedAddress: PatientAddress[] = [];
    modifiedAddress.push(this.patientWorkAddress)
    this.patientService.updatePatientEmployerInfo(this.patientEmployer).subscribe(
      (_) => {
        self.patientProfile.patientEmployerInfo[0] = self.patientEdit.patientEmployerInfo[0];
        self.toggleEvent.emit(self.patientProfile);
      },
      (error) => { console.error(error); }
    );
    this.patientService.updatePatientAddressDetails(modifiedAddress).subscribe(
      (_) => {
        self.toggleEvent.emit(self.patientProfile);
      },
      (error) => { console.error(error); }
    );

  }

  updatePatientMilitaryStatus() {
    const self = this;
    let data = { patientId: this.patientEdit.id, militaryStatus: this.patientEdit.militaryStatus, serviceBranch: this.patientEdit.serviceBranch }
    this.patientService.updatePatientMilitaryStatus(data).subscribe(
      (_) => {
        self.patientProfile = self.patientEdit;
        self.toggleEvent.emit(self.patientProfile);
      },
      (error) => { console.error(error); }
    );
  }

  setPreferredContact() {
    this.homeContact = this.patientEdit && this.patientEdit.patientContactPreferences ? this.patientEdit.patientContactPreferences.find(pc => pc.contactType == 'HOMENUMBER') : null;
    this.mobileContact = this.patientEdit && this.patientEdit.patientContactPreferences ? this.patientEdit.patientContactPreferences.find(pc => pc.contactType == 'MOBILENUMBER') : null;
    this.workContact = this.patientEdit && this.patientEdit.patientContactPreferences ? this.patientEdit.patientContactPreferences.find(pc => pc.contactType == 'WORKNUMBER') : null;
    this.emailContact = this.patientEdit && this.patientEdit.patientContactPreferences ? this.patientEdit.patientContactPreferences.find(pc => pc.contactType == 'EMAIL') : null;

    if (this.homeContact)
      this.patientContactForm.get('homePhone').setValue(this.homeContact.contactValue);

    if (this.mobileContact)
      this.patientContactForm.get('mobilePhone').setValue(this.mobileContact.contactValue);

    if (!this.homeContact) {
      this.homeContact = new PatientContactPreferences;
      this.homeContact.active = true;
      this.homeContact.contactType = 'HOMENUMBER';
      this.homeContact.isCallAllowed = false;
      this.homeContact.isPreferred = false;
      this.homeContact.isTextAllowed = false;
      this.homeContact.patientId = this.patientEdit.id;
    }
    if (!this.mobileContact) {
      this.mobileContact = new PatientContactPreferences;
      this.mobileContact.active = true;
      this.mobileContact.contactType = 'MOBILENUMBER';
      this.mobileContact.isCallAllowed = false;
      this.mobileContact.isPreferred = false;
      this.mobileContact.isTextAllowed = false;
      this.mobileContact.patientId = this.patientEdit.id;
    }
    if (!this.workContact) {
      this.workContact = new PatientContactPreferences;
      this.workContact.active = true;
      this.workContact.contactType = 'WORKNUMBER';
      this.workContact.isCallAllowed = false;
      this.workContact.isPreferred = false;
      this.workContact.isTextAllowed = false;
      this.workContact.patientId = this.patientEdit.id;
    }
    if (!this.emailContact) {
      this.emailContact = new PatientContactPreferences;
      this.emailContact.active = true;
      this.emailContact.contactType = 'EMAIL';
      this.emailContact.isCallAllowed = false;
      this.emailContact.isPreferred = false;
      this.emailContact.isTextAllowed = false;
      this.emailContact.patientId = this.patientEdit.id;
    }
  }

  saveContactPreferences() {
    if (this.patientContactForm.invalid) {
      this.patientContactForm.markAsTouched();
      return;
    }
    this.homeContact.contactValue = this.patientContactForm.get('homePhone').value;
    this.mobileContact.contactValue = this.patientContactForm.get('mobilePhone').value;
    if (this.homeContact.contactValue && this.homeContact.contactValue.length < 10) {
      this.utils.showMessageSnackBar('Please enter valid Home Contact', true);
      return;
    }
    if (this.mobileContact.contactValue && this.mobileContact.contactValue.length < 10) {
      this.utils.showMessageSnackBar('Please enter valid Mobile Contact', true);
      return;
    }
    if (this.workContact.contactValue && this.workContact.contactValue.length < 10) {
      this.utils.showMessageSnackBar('Please enter valid Work Contact', true);
      return;
    }

    const contacts = new PatientContactPreferencesReq;
    contacts.patientId = this.patientEdit.id;
    if (this.emailContact.contactValue) {
      if (!this.utils.isValidEmail(this.emailContact.contactValue)) {
        this.utils.showMessageSnackBar('Please enter valid email', true);
        return;
      }
    }
    else {
      this.utils.showMessageSnackBar('Please enter email', true);
      return;
    }
    // contacts.photoUrl = this.patientEdit.photoUrl;
    if (this.patientEdit.isVisuallyImpaired === 'Yes') {
      this.patientEdit.isVisuallyImpaired = true;
      contacts.isVisuallyImpaired = true;
    } else {
      this.patientEdit.isVisuallyImpaired = false;
      contacts.isVisuallyImpaired = false;
    }
    if (this.patientEdit.isHearingImpaired === 'Yes') {
      this.patientEdit.isHearingImpaired = true;
      contacts.isHearingImpaired = true;
    } else {
      this.patientEdit.isHearingImpaired = false;
      contacts.isHearingImpaired = false;
    }
    contacts.patientContactPreferenceDetails = [];
    // contacts.patientContactPreferenceDetails = this.patientEdit.patientContactPreferences;
    // this.patientEdit.patientContactPreferences.filter(q => q.contactType == 'HOMENUMBER').forEach(element => {
    //   contacts.patientContactPreferenceDetails.filter(q => q.contactType == 'HOMENUMBER')[0].isCallAllowed = element.isCallAllowed;
    // });

    // this.patientEdit.patientContactPreferences.filter(q => q.contactType == 'MOBILENUMBER').forEach(element => {
    //   contacts.patientContactPreferenceDetails.filter(q => q.contactType == 'MOBILENUMBER')[0].isCallAllowed = element.isCallAllowed;
    //   contacts.patientContactPreferenceDetails.filter(q => q.contactType == 'MOBILENUMBER')[0].isTextAllowed = element.isTextAllowed;

    // });

    if (this.homeContact) {
      contacts.patientContactPreferenceDetails.push(this.homeContact);
    }
    if (this.mobileContact) {
      contacts.patientContactPreferenceDetails.push(this.mobileContact);
    }
    if (this.workContact) {
      contacts.patientContactPreferenceDetails.push(this.workContact);
    }
    if (this.emailContact) {
      contacts.patientContactPreferenceDetails.push(this.emailContact);
    }

    if (this.patientProfileImageFile != undefined) {
      const payload = new FormData();
      payload.append('PatientId', this.patientEdit.id.toString());
      payload.append('ImageSource', this.patientProfileImageFile);

      this.patientService.uploadPatientProfilePicture(payload).subscribe(
        (res) => {
          if (res['isSuccess']) {
            this.patientService.getCurrentPatientDetails().subscribe(
              (data: Patient) => {
                this.patientProfile = data;
              },
              (error) => { console.error(error); });
          }
        },
        (error) => { console.error(error); }
      );
    }

    const self = this;
    this.patientService.updatePatientContactPreferences(contacts).subscribe(
      (_) => {
        self.patientEdit.patientContactPreferences = contacts.patientContactPreferenceDetails;
        self.patientProfile = self.patientEdit;
        self.toggleEvent.emit(self.patientProfile);
      },
      (error) => { console.error(error); }
    );

  }
}

